import { render, staticRenderFns } from "./bi-financial-strength-rating.vue?vue&type=template&id=58e4d918&"
import script from "./bi-financial-strength-rating.vue?vue&type=script&lang=ts&"
export * from "./bi-financial-strength-rating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports